<!-- Desktop sidebar -->
<aside
    class="hidden lg:flex flex-col overflow-hidden transition-all duration-300 ease-in-out"
    style="background: var(--dgpe-navy); color: #ffffff; border-radius: 20px; margin: 12px 0 12px 8px"
    [style.min-width]="collapsed() ? '72px' : '240px'"
    [style.width]="collapsed() ? '72px' : '240px'">
    <!-- Scrollable menu area -->
    <nav class="flex-1 overflow-y-auto pt-5 px-3 sidebar-scroll">
        @for (menu of menuService.menuItems(); track menu.id) {
            @if (menu.etat && !isBottomMenu(menu)) {
                <ng-container *ngTemplateOutlet="navItem; context: { $implicit: menu, depth: 0, collapsed: collapsed() }" />
            }
        }
    </nav>

    <!-- Bottom fixed -->
    <div class="flex-shrink-0 px-3 pb-4 pt-3 space-y-0.5" style="border-top: 1px solid rgba(255, 255, 255, 0.08)">
        @for (menu of menuService.menuItems(); track menu.id) {
            @if (menu.etat && isBottomMenu(menu)) {
                <a
                    class="sidebar-item"
                    routerLinkActive="sidebar-active"
                    [class.justify-center]="collapsed()"
                    [routerLink]="menu.url"
                    [title]="collapsed() ? menu.label : ''">
                    <span class="flex-shrink-0 w-5 h-5" [innerHTML]="icon(menu.icon)"></span>
                    @if (!collapsed()) {
                        <span class="text-md font-medium truncate">{{ menu.label }}</span>
                    }
                </a>
            }
        }

        <!-- Aide & support : placeholder inactif (aucune page d'aide n'existe encore) -->
        <span class="sidebar-item opacity-60 cursor-default" [class.justify-center]="collapsed()" [title]="collapsed() ? 'Aide & support' : ''">
            <span class="flex-shrink-0 w-5 h-5" [innerHTML]="helpIcon"></span>
            @if (!collapsed()) {
                <span class="text-md font-medium truncate">Aide & support</span>
            }
        </span>

        <!-- Déconnexion -->
        <button
            class="sidebar-item sidebar-logout w-full"
            type="button"
            [class.justify-center]="collapsed()"
            [title]="collapsed() ? 'Déconnexion' : ''"
            (click)="onLogout()">
            <span class="flex-shrink-0 w-5 h-5" [innerHTML]="logoutIcon"></span>
            @if (!collapsed()) {
                <span class="text-md font-medium truncate">Déconnexion</span>
            }
        </button>
    </div>
</aside>

<!-- Mobile overlay -->
@if (mobileOpen()) {
    <div class="lg:hidden fixed inset-0 z-40">
        <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="mobileOpen.set(false)"></div>
        <aside class="absolute left-0 top-0 h-full w-[240px] flex flex-col shadow-2xl" style="background: #1a2e2a; border-radius: 20px">
            <!-- Close button -->
            <div class="flex justify-end p-3">
                <button
                    aria-label="Fermer le menu"
                    class="p-1.5 rounded-lg"
                    style="color: rgba(255, 255, 255, 0.5)"
                    type="button"
                    (click)="mobileOpen.set(false)">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    </svg>
                </button>
            </div>

            <!-- Mobile menu (toujours déployé, accordéons N niveaux) -->
            <nav class="flex-1 overflow-y-auto px-3 sidebar-scroll">
                @for (menu of menuService.menuItems(); track menu.id) {
                    @if (menu.etat && !isBottomMenu(menu)) {
                        <ng-container *ngTemplateOutlet="navItem; context: { $implicit: menu, depth: 0, collapsed: false }" />
                    }
                }
            </nav>

            <!-- Mobile bottom -->
            <div class="flex-shrink-0 px-3 pb-4 pt-3 space-y-0.5" style="border-top: 1px solid rgba(255, 255, 255, 0.08)">
                @for (menu of menuService.menuItems(); track menu.id) {
                    @if (menu.etat && isBottomMenu(menu)) {
                        <a class="sidebar-item" routerLinkActive="sidebar-active" [routerLink]="menu.url" (click)="mobileOpen.set(false)">
                            <span class="flex-shrink-0 w-5 h-5" [innerHTML]="icon(menu.icon)"></span>
                            <span class="text-md font-medium truncate">{{ menu.label }}</span>
                        </a>
                    }
                }
                <span class="sidebar-item opacity-60 cursor-default">
                    <span class="flex-shrink-0 w-5 h-5" [innerHTML]="helpIcon"></span>
                    <span class="text-md font-medium truncate">Aide & support</span>
                </span>
                <button class="sidebar-item sidebar-logout w-full" type="button" (click)="onLogout()">
                    <span class="flex-shrink-0 w-5 h-5" [innerHTML]="logoutIcon"></span>
                    <span class="text-md font-medium truncate">Déconnexion</span>
                </button>
            </div>
        </aside>
    </div>
}

<!--
  Élément de menu RÉCURSIF (N niveaux). Un nœud à sous-menus = groupe accordéon
  (dépliable, indenté par .collapsible-body imbriqués) ; sinon = feuille (lien).
  Contexte : { $implicit: menu, depth, collapsed }. Rétro-compatible avec l'arbre
  3 niveaux existant ; déplie automatiquement tout niveau supplémentaire servi par
  le backend.
-->
<ng-template #navItem let-collapsed="collapsed" let-depth="depth" let-menu>
    @if (menu.etat) {
        @if (isSection(menu)) {
            <!-- Séparateur de groupe : libellé statique, JAMAIS déroulant ; enfants rendus directement -->
            @if (!collapsed) {
                <div class="section-header">{{ menu.label }}</div>
            }
            @for (child of menu.sous_menus; track child.id) {
                <ng-container *ngTemplateOutlet="navItem; context: { $implicit: child, depth: depth, collapsed: collapsed }" />
            }
        } @else if (hasChildren(menu)) {
            <!-- Groupe déroulant (accordéon) -->
            <button
                class="collapsible-header"
                type="button"
                [attr.aria-expanded]="isMenuOpen(menu.id)"
                [attr.aria-label]="collapsed ? menu.label : null"
                [class.justify-center]="collapsed"
                (click)="toggleMenu(menu.id)">
                <span aria-hidden="true" class="flex-shrink-0 w-5 h-5" [innerHTML]="icon(menu.icon)"></span>
                @if (!collapsed) {
                    <span class="text-md font-semibold truncate flex-1 text-left">{{ menu.label }}</span>
                    <svg
                        aria-hidden="true"
                        class="chevron w-4 h-4 flex-shrink-0 transition-transform duration-200"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        [class.chevron-open]="isMenuOpen(menu.id)">
                        <path d="M19 9l-7 7-7-7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                    </svg>
                }
            </button>

            @if (!collapsed && isMenuOpen(menu.id)) {
                <div class="collapsible-body">
                    @for (child of menu.sous_menus; track child.id) {
                        <ng-container *ngTemplateOutlet="navItem; context: { $implicit: child, depth: depth + 1, collapsed: collapsed }" />
                    }
                </div>
            }
        } @else {
            <!-- Feuille (lien) -->
            <a
                class="sidebar-item"
                [class.justify-center]="collapsed"
                [class.sidebar-active]="isLeafActive(menu.url)"
                [class.sidebar-leaf]="depth > 0"
                [routerLink]="menu.url"
                [title]="collapsed ? menu.label : ''"
                (click)="onLeafClick()">
                <span class="flex-shrink-0 w-5 h-5" [innerHTML]="icon(menu.icon)"></span>
                @if (!collapsed) {
                    <span class="text-md font-medium truncate">{{ menu.label }}</span>
                }
            </a>
        }
    }
</ng-template>
